import { __rest, __assign } from '../../_virtual/_tslib.js';
import React, { useRef, useState, useEffect } from 'react';
import classnames from 'classnames';
import ScrollLock from 'react-scrolllock';
import upperFirst from 'lodash/upperFirst';
import elevationStyles from '../../elevations.css.js';
import ReactDOM from 'react-dom';
import styles from './styles.css.js';
import clientOnly from '../../hocs/clientOnly.js';
import CloseIcon from './close.svg.js';

var FlyoutHeader = function FlyoutHeader(_a) {
  var title = _a.title,
      className = _a.className,
      onClose = _a.onClose,
      rest = __rest(_a, ["title", "className", "onClose"]);

  return React.createElement("div", __assign({
    className: classnames(styles.header, className)
  }, rest), React.createElement("span", null, title), React.createElement(CloseIcon, {
    className: styles.closeIcon,
    onClick: onClose
  }));
};
var FlyoutContent = function FlyoutContent(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  return React.createElement("div", __assign({
    className: classnames(styles.content, className)
  }, rest));
};

var Flyout = function Flyout(_a) {
  var _b;

  var isOpen = _a.isOpen,
      _c = _a.from,
      from = _c === void 0 ? 'right' : _c,
      width = _a.width,
      onClose = _a.onClose,
      overlayClassName = _a.overlayClassName,
      flyoutClassName = _a.flyoutClassName,
      flyoutContentClassName = _a.flyoutContentClassName,
      _d = _a.elevation,
      elevation = _d === void 0 ? 'lowest' : _d,
      children = _a.children,
      rest = __rest(_a, ["isOpen", "from", "width", "onClose", "overlayClassName", "flyoutClassName", "flyoutContentClassName", "elevation", "children"]);

  var scrollableContainerRef = useRef(null);

  var _e = useState(false),
      animateClose = _e[0],
      setAnimateClose = _e[1];

  var _f = useState(false),
      renderChildren = _f[0],
      setRenderChildren = _f[1];

  var timeout = useRef();
  useEffect(function () {
    var _a, _b;

    if (isOpen) {
      timeout.current && clearTimeout(timeout.current);
      setRenderChildren(true);
      /**
       * If the close animation is applied on mount, you can see the flyout closing.
       *   To prevent this, apply the animate css after the first time the flyout is open.
       */

      if (!animateClose) {
        setAnimateClose(true);
      }
    } else {
      /**
       * Use a setTimeout to keep the contents of the flyout on screen as it closes.
       */
      timeout.current = setTimeout(function () {
        return setRenderChildren(false);
      }, 600);
      /**
       * Scroll back to the top after closing the flyout
       *
       * If the first child of the ScrollLock has a ref attribute, it will be overriden by ScrollLock's manipulation
       *   of it's direct child. If we add another div inbetween the ScrollLock and scrollable container, scrolling
       *   doesn't work at all on iOS. With this solution, we find the scrollable container via a data attribute and a
       *   ref from parent ABOVE the ScrollLock. This reaches in and prevents the ref collision.
       */

      (_b = (_a = scrollableContainerRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('[data-name="scrollable-container"]')) === null || _b === void 0 ? void 0 : _b.scrollTo({
        top: 0
      });
    }
  }, [isOpen]);
  return ReactDOM.createPortal(React.createElement("div", __assign({
    className: classnames(styles.overlay, elevationStyles["elevation" + upperFirst(elevation)], overlayClassName, (_b = {}, _b[styles.open] = isOpen, _b[styles.animateClose] = animateClose, _b)),
    onClick: onClose
  }, rest), React.createElement("div", {
    className: classnames(styles.flyout, width && styles[width], from === 'left' ? styles.left : styles.right, flyoutClassName),
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    ref: scrollableContainerRef
  }, React.createElement(ScrollLock, {
    isActive: isOpen
  }, React.createElement("div", {
    "data-name": "scrollable-container",
    className: classnames(styles.flyoutContent, flyoutContentClassName)
  }, renderChildren ? children : null)))), document.body);
};

var index = clientOnly(Flyout);

export default index;
export { FlyoutContent, FlyoutHeader };
//# sourceMappingURL=index.js.map
